import '../../../css/bem/_associated_product.scss';

export const wishlistGetProductId = (ele) => {
    if (ele.dataset.pid) return ele.dataset.pid;
    return ele.closest('[data-pid]').getAttribute('data-pid');
};

const NAV_SELECTOR = '.associated-product-gallery__nav';
const GALLERY_SELECTOR = '.js-associated-product-gallery';
const VIEWPORT_SELECTOR = '.associated-product-gallery__swiper';

let galleryNavHandler: Promise<(event: Event) => void> | null = null;

export const setGalleryNavsDisabled = (disabled: boolean) => {
    document.querySelectorAll<HTMLButtonElement>(NAV_SELECTOR).forEach((button) => {
        button.classList.toggle('disabled', disabled);
        button.disabled = disabled;
    });
};

const loadGalleryNavHandler = () => {
    if (!galleryNavHandler) {
        galleryNavHandler = import('../associated-product-gallery/associated-product-gallery').then(
            (gallery) => gallery.handleNavClick
        );
    }

    return galleryNavHandler;
};

document.addEventListener(
    'click',
    (event) => {
        if (!(event.target instanceof Element)) return;

        const nav = event.target.closest(NAV_SELECTOR) as HTMLButtonElement | null;
        if (!nav) return;

        event.preventDefault();
        event.stopPropagation();

        if (nav.disabled || nav.classList.contains('disabled')) return;

        const gallery = nav.closest(GALLERY_SELECTOR);
        if (gallery && !gallery.querySelector(VIEWPORT_SELECTOR)) {
            setGalleryNavsDisabled(true);
        }

        loadGalleryNavHandler()
            .then((handleNavClick) => handleNavClick(event))
            .catch(() => {
                setGalleryNavsDisabled(false);
            });
    },
    true
);
